import PolicyLayout from './PolicyLayout';
import { POLICY_UPDATED, SUPPORT_EMAIL } from '../constants/site';

export default function RefundPolicy() {
  return (
    <PolicyLayout
      title="Refund Policy"
      updated={POLICY_UPDATED}
      intro="We would rather fix the problem than keep your money. Here is exactly when a refund applies."
    >
      <h2>Diagnostics</h2>
      <p>
        The initial consultation is free. If we take on a paid diagnosis and cannot identify
        the cause of the fault, the diagnosis fee is refunded in full.
      </p>

      <h2>Repair work</h2>
      <p>
        If an approved repair does not resolve the issue described in the quote, we will
        either continue at no extra cost or refund the fee for that item, whichever you
        prefer.
      </p>

      <h2>Software licences</h2>
      <p>
        Accounting software licences are issued by the software publisher and are covered by the
        publisher&apos;s money-back guarantee under their end user licence agreement. Once a
        product key has been redeemed, refunds are handled under the publisher&apos;s terms; we
        will help you raise the request.
      </p>

      <h2>Subscriptions</h2>
      <p>
        Ongoing bookkeeping plans can be cancelled with 14 days notice. Any prepaid period
        beyond the notice date is refunded pro rata.
      </p>

      <h2>How to request a refund</h2>
      <p>
        Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> with your invoice number
        and a short description of the issue. Approved refunds are returned to the original
        payment method within 5 to 10 business days.
      </p>
    </PolicyLayout>
  );
}
